import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { MapPinIcon, CalendarIcon, BanknoteIcon, ArrowRightIcon } from 'lucide-react';
import { Project } from '../../data/projects';
interface ProjectCardProps {
  project: Project;
  index: number;
}
export function ProjectCard({
  project,
  index
}: ProjectCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: index * 0.05
  }} data-id="element-352">
      <Card hover className="h-full flex flex-col" data-id="element-353">
        <div className="flex items-start justify-between mb-3" data-id="element-354">
          <span className="inline-block bg-au-green-light text-au-green text-xs font-semibold px-3 py-1 rounded-full" data-id="element-355">
            {project.sector}
          </span>
          <StatusPill status={project.status} data-id="element-356">
            {project.status.toUpperCase()}
          </StatusPill>
        </div>

        <h3 className="text-xl font-bold text-charcoal mb-3 leading-snug" data-id="element-357">
          {project.title}
        </h3>

        <div className="flex items-start gap-2 text-sm text-gray-600 mb-3" data-id="element-358">
          <MapPinIcon size={16} className="flex-shrink-0 mt-0.5" data-id="element-359" />
          <span data-id="element-360">{project.countries.join(', ')}</span>
        </div>

        <p className="text-gray-600 text-sm mb-4 flex-1" data-id="element-361">
          {project.description}
        </p>

        <div className="space-y-2 pt-4 border-t border-gray-border" data-id="element-362">
          <div className="flex items-center justify-between text-sm" data-id="element-363">
            <div className="flex items-center gap-2 text-gray-600" data-id="element-364">
              <BanknoteIcon size={16} data-id="element-365" />
              <span data-id="element-366">Budget</span>
            </div>
            <span className="font-bold text-au-green" data-id="element-367">{project.budget}</span>
          </div>
          <div className="flex items-center justify-between text-sm" data-id="element-368">
            <div className="flex items-center gap-2 text-gray-600" data-id="element-369">
              <CalendarIcon size={16} data-id="element-370" />
              <span data-id="element-371">Timeline</span>
            </div>
            <span className="font-medium text-charcoal" data-id="element-372">
              {new Date(project.startDate).getFullYear()}
              {project.endDate ? ` – ${new Date(project.endDate).getFullYear()}` : ''}
            </span>
          </div>
        </div>

        <button className="mt-4 flex items-center gap-1 text-au-green font-medium text-sm hover:gap-2 transition-all" data-id="element-373">
          <span data-id="element-374">View Project Details</span>
          <ArrowRightIcon size={16} data-id="element-375" />
        </button>
      </Card>
    </motion.div>;
}